import { OnboardingStep } from 'types/onboardingTypes'

export function getYourGoalsInfo(): OnboardingStep {
  return {
    id: 'your_goals_info',
    type: 'custom'
  }
}
